<template>
    <v-app>
         <v-layout wrap justify-center> 
       
        <table>
            <thead>
                <tr>
                    <th id="left">Upper Body</th>
                    <th>Left (kg)</th>
                    <th id="right">Right (kg)</th>
                       <th >Remarks</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(emg, index) in emgReading" :key="emg['id']">
                    <td>{{ emg.type }}</td>
                    <td><input type="number" v-model="strength_upper_left[index]" placeholder="Insert Num"></td>
                    <td><input type="number" v-model="strength_upper_right[index]" placeholder="Insert Num"></td>
                    <td><textarea v-model="strength_upper_remarks[index]" />  </td>
                </tr>  
                  
            </tbody>            
        </table>
         <table>
            <thead>
                <tr>
                    <th id="left">Lower Body</th>
                    <th>Left (kg)</th>
                    <th id="right">Right (kg)</th>
                     <th >Remarks</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(emg, index) in emgReading2" :key="emg['id']">
                    <td>{{ emg.type }}</td>
                    <td><input type="number" v-model="strength_lower_left[index]" placeholder="Insert Num"></td>
                    <td><input type="number" v-model="strength_lower_right[index]" placeholder="Insert Num"></td>
                         <td><textarea v-model="strength_lower_remarks[index]" /></td>
                </tr>  
                  
            </tbody>            
        </table>
        <v-btn  color="black" @click="$emit('submitForm'); isAssessing = true" :disabled="isAssessing" style="max-height: 50px;">Finish Assessing</v-btn>
         </v-layout>    
    </v-app>
</template>
<script>
import db from '@/components/firebase.init';
export default {
    data(){
        return{
            isAssessing: false,
           strength_upper_left:[0,0,0,0],
           strength_upper_right:[0,0,0,0],
              strength_lower_left:[0,0,0,0],
           strength_lower_right:[0,0,0,0],
              strength_upper_remarks:['','','',''],
                strength_lower_remarks:['','','',''],
            emgReading:[
                {
                    type: 'Internal Rotation'
                },
                {
                    type: 'External Rotation'
                },
                {
                    type: 'Shoulder Abduction'
                },
                {
                    type: 'Shoulder Blade Abduction'
                },
            ],
              emgReading2:[
                {
                    type: 'Hip Extension'
                },
                {
                    type: 'Hip Flexion'
                },
                {
                    type: 'Knee Flexion'
                },
                {
                    type: 'Knee Extension'
                },
            ]
        }
    },
    methods:{
        submit(id){
          
            db.collection('forms').doc(id).update(
                {
                 strength_upper_left:this.strength_upper_left,
           strength_upper_right:this.strength_upper_right,
              strength_lower_left:this.strength_lower_left,
           strength_lower_right:this.strength_lower_right,
              strength_upper_remarks:this.strength_upper_remarks,
                strength_lower_remarks:this.strength_lower_remarks,
         status: "GENERATING REPORT"
                }
            )
            .then(()=>{
       this.isAssessing = false;
            })
            .catch(e =>{
     this.isAssessing = false;
            })
        }
    }
}
</script>
<style scoped>
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 425px;
    height: 450px;
    margin: -225px 0 0 -212.5px;
    background-color : white;
    text-align: center;
    color: rgba(0,0,0,0.6);
    font-weight: 600;
    border-radius: 5px;
    padding-bottom: 0px;
}
table { 

    }
th {
    background-color: #555;
    color: white;   
    
}
tr td:nth-child(1){
    width: 100px;
}
tr td{
    width: 50vw;
}
#left {
    border-radius: 5px 0 0 0;
}
#right {
    border-radius: 0 5px 0 0;
}
td, th {
    padding: 10px;
    border-bottom: 1px  solid #ccc; 
}
h5 {
    margin: 0px;
    opacity: .8;
}
input {
    width: 100px;
    border: 0;
}
textarea:focus, input:focus{
    outline: none;
}
</style>


